import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    FirstName: {
      validations: []
    },
    LastName: {
      validations: []
    },
    TelNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    Email: {
      validations: [
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    AddressLine1: {
      validations: []
    },
    City: {
      validations: []
    },
    State: {
      validations: []
    },
    Postal: {
      validations: [
        { type: 'maxLength', maxLength: 5, message: 'Enter 5 digit zip code' }
      ]
    },
    Category: {
      validations: []
    },
    AccountExtra1: {
      validations: []
    },
    AllergyInfo: {
      validations: []
    },
    PlannedGuestCount: {
      validations: [
        {type: 'regex', pattern: '^[0-9]*$', message: 'Please provide in numbers only.'}
      ]
    },
    EventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future.' }
      ]
    },
    AccountExtra2: {
      validations: []
    },
    SiteAddress: {
      validations: []
    },
    SiteCity: {
      validations: []
    },
    SiteState: {
      validations: []
    },
    SitePostal: {
      validations: [
        { type: 'maxLength', maxLength: 5, message: 'Enter 5 digit zip code' }
      ]
    },
    Reference: {
      validations: []
    },
    Notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name',
            mapping: 'FirstName'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Last Name',
            mapping: 'LastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number',
            mapping: 'TelNumber'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Email',
            mapping: 'Email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Address:',
            mapping: 'AddressLine1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City:',
            mapping: 'City'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'State:',
            options: [
              { label: 'AL', value: 'AL' },
              { label: 'AK', value: 'AK' },
              { label: 'AZ', value: 'AZ' },
              { label: 'AR', value: 'AR' },
              { label: 'CA', value: 'CA' },
              { label: 'CO', value: 'CO' },
              { label: 'CT', value: 'CT' },
              { label: 'DE', value: 'DE' },
              { label: 'DC', value: 'DC' },
              { label: 'FL', value: 'FL' },
              { label: 'GA', value: 'GA' },
              { label: 'HI', value: 'HI' },
              { label: 'ID', value: 'ID' },
              { label: 'IL', value: 'IL' },
              { label: 'IN', value: 'IN' },
              { label: 'IA', value: 'IA' },
              { label: 'KS', value: 'KS' },
              { label: 'KY', value: 'KY' },
              { label: 'LA', value: 'LA' },
              { label: 'ME', value: 'ME' },
              { label: 'MD', value: 'MD' },
              { label: 'MA', value: 'MA' },
              { label: 'MI', value: 'MI' },
              { label: 'MN', value: 'MN' },
              { label: 'MS', value: 'MS' },
              { label: 'MO', value: 'MO' },
              { label: 'MT', value: 'MT' },
              { label: 'NE', value: 'NE' },
              { label: 'NV', value: 'NV' },
              { label: 'NH', value: 'NH' },
              { label: 'NJ', value: 'NJ' },
              { label: 'NM', value: 'NM' },
              { label: 'NY', value: 'NY' },
              { label: 'NC', value: 'NC' },
              { label: 'ND', value: 'ND' },
              { label: 'OH', value: 'OH' },
              { label: 'OK', value: 'OK' },
              { label: 'OR', value: 'OR' },
              { label: 'PA', value: 'PA' },
              { label: 'RI', value: 'RI' },
              { label: 'SC', value: 'SC' },
              { label: 'SD', value: 'SD' },
              { label: 'TN', value: 'TN' },
              { label: 'TX', value: 'TX' },
              { label: 'UT', value: 'UT' },
              { label: 'VT', value: 'VT' },
              { label: 'VA', value: 'VA' },
              { label: 'WA', value: 'WA' },
              { label: 'WV', value: 'WV' },
              { label: 'WI', value: 'WI' },
              { label: 'WY', value: 'WY' }
            ],
            mapping: 'State'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Zip:',
            mapping: 'Postal'
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Customer Details',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Service Requested',
            options:[
              {label: 'PMRI Alumni Menu' , value: 'PMRI Alumni Menu'},
              {label: 'MarinHealth Alumni Menu' , value: 'MarinHealth Alumni Menu'},
              {label: 'Corporate Catering' , value: 'Corporate Catering'},
              {label: 'Medical Catering' , value: 'Medical Catering'},
              {label: 'Event Catering' , value: 'Event Catering'},
              {label: 'Family Meal Plans' , value: 'Family Meal Plans'},
              {label: 'Great Plates' , value: 'Great Plates'},
            ],
            mapping: 'Category'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Dietary Preference',
            options: [
              { label: 'No Preference', value: 'No Preference' },
              { label: 'Paleo', value: 'Paleo' },
              { label: 'Plant-Forward', value: 'Plant-Forward' },
              { label: 'Vegetarian', value: 'Vegetarian' },
              { label: 'Vegan', value: 'Vegan' },
              { label: 'Other', value: 'Other' },
            ],
            mapping: 'AccountExtra1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Allergy Info',
            mapping: 'AllergyInfo'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'How Many People?',
            mapping: 'PlannedGuestCount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker-nofill',
            size: 'Medium',
            label: 'Date requested',
            mapping: 'EventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Frequency',
            options: [
              { label: 'Single Event', value: 'Single Event' },
              { label: 'Daily', value: 'Daily' },
              { label: 'Weekly', value: 'Weekly' },
              { label: 'Monthly', value: 'Monthly' },
            ],
            mapping: 'AccountExtra2'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Event Address',
            mapping: 'SiteAddress'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Event City',
            mapping: 'SiteCity'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Event State',
            mapping: 'SiteState'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Event Zip',
            mapping: 'SitePostal'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'How did you find us?',
            options: [
              { label: 'Internet', value: 'Internet' },
              { label: 'E-Mail', value: 'E-Mail' },
              { label: 'Brochure', value: 'Brochure' },
              { label: 'Constant Contact', value: 'Constant Contact' },
              { label: 'Healthcare Provider', value: 'Healthcare Provider' },
              { label: 'Friend/Family', value: 'Friend/Family' },
              { label: 'FaceBook', value: 'FaceBook' },
              { label: 'Instagram', value: 'Instagram' },
              { label: 'LinkedIn', value: 'LinkedIn' },
            ],
            mapping: 'Reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Additional Information or Comments:',
            mapping: 'Notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Farmacary Contact Form',
    formId: '708',
    clientKey: '9ACAFA2D-2ED1-4A17-82C4-E3FA275C01A8',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/farmacary/form_structure.js